import { useSyncExternalStore } from 'react';

/** Lets the Topbar's search box (and anything else) open the same
 * `CommandPalette` the Ctrl/⌘K shortcut does, without prop-drilling open
 * state through `AppShell` — a plain module-level store is enough for a
 * single boolean two call sites share. */
let isOpen = false;
const listeners = new Set<() => void>();

function emit() {
  for (const l of listeners) l();
}

export function openCommandPalette() {
  isOpen = true;
  emit();
}

export function closeCommandPalette() {
  isOpen = false;
  emit();
}

export function toggleCommandPalette() {
  isOpen = !isOpen;
  emit();
}

export function useCommandPaletteOpen(): boolean {
  return useSyncExternalStore(
    (onChange) => {
      listeners.add(onChange);
      return () => listeners.delete(onChange);
    },
    () => isOpen,
  );
}
